import {
  getOrthoOrientation,
  getBeamOrientation,
  getMountingStructurePositions,
} from '~/components/DrawingCanvas/MountingStructures/util'
import { useSelectedRoofSectionContext } from '~/components/Panels/SelectedRoofSectionPanel/hooks/useSelectedRoofSectionContext'
import { TABS } from '~/components/Panels/SelectedRoofSectionPanel/util'
import { LETTERS } from '~/config/letters'
import { useAppSelector } from '~/store/hooks'
import { DimensionInput } from '~/ui/DimensionInput'
import { Switch } from '~/ui/Switch'
import { TabPanel } from '~/ui/Tabs'
import { TextField } from '~/ui/TextField'

export const ColumnsTabPanel = () => {
  const { selectedRoofSection, handleUpdate } = useSelectedRoofSectionContext()
  const { hasColumns, perimeterPoints, beamRotation, columnSpacing, columnWidth, isCylinder, beamNames } =
    selectedRoofSection
  const isLocked = useAppSelector(state => state.layers.layers.ROOF_SECTIONS.locked)

  const handleUpdateSpacing = (value: number) => {
    const columnOrientation = getOrthoOrientation(getBeamOrientation(beamRotation))
    handleUpdate({
      columnSpacing: value,
      columnLineModels: getMountingStructurePositions(perimeterPoints, columnOrientation, value),
    })
  }

  return (
    <TabPanel className="p-1 space-y-3" id={TABS.columns}>
      <Switch
        isDisabled={isLocked}
        className="p-1 text-xs"
        isSelected={hasColumns}
        onChange={selected => handleUpdate({ hasColumns: selected })}
      >
        Has columns
      </Switch>
      <DimensionInput
        showStepperButtons
        isDisabled={isLocked}
        label="Column Spacing"
        value={columnSpacing}
        onCommit={handleUpdateSpacing}
      />
      <DimensionInput
        showStepperButtons
        isDisabled={isLocked}
        label="Column Size"
        value={columnWidth}
        onCommit={value => handleUpdate({ columnLength: value, columnWidth: value })}
      />
      <Switch
        isDisabled={isLocked}
        className="p-1 text-xs"
        isSelected={isCylinder}
        onChange={selected => handleUpdate({ isCylinder: selected })}
      >
        Round Columns
      </Switch>
      <TextField
        isDisabled={isLocked}
        label="Beam Labels"
        value={beamNames.join(',')}
        onChange={value => handleUpdate({ beamNames: (value || LETTERS.join(',')).split(',') })}
        description="Enter a list to be used for your beam labels, EX: A1, B1, C1"
      />
    </TabPanel>
  )
}
